import type { ValidationConfig } from '../../../core/dataProcessor/types';

// 🆕 为新 ValidationEngine 导出的配置
export const gaugeValidationConfig: ValidationConfig = {
  fields: [{ field: 'x', type: 'number', required: true }],
  businessRules: [
    {
      name: 'gauge-sufficient-data',
      validator: data => Array.isArray(data) && data.length > 1,
      message: 'Gauge chart requires more than 1 data point',
      suggestion: 'Provide at least 2 data points for proper gauge display',
      // 推荐性建议，不影响图表渲染
      severity: 'warning'
    }
  ]
};
